import * as BannerTileActions from '../actions/actions-banner-tile';
import { Action, createReducer, on } from '@ngrx/store';
import { MBanner } from '../models/banner';

export interface State {
  banner: MBanner[];
  size: string;
  isLoading: boolean;
  loadingError: string;
}

const initialState: State = {
  banner: null,
  size: '',
  isLoading: false,
  loadingError: ''
};

const bannerTileReducer = createReducer(
  initialState,
  on(BannerTileActions.GetBannerTile, state => ({
    ...state,
    isLoading: true,
    loadingError: ''
  })),
  on(BannerTileActions.GetBannerTileSuccess, (state, { banners, bannersSize }) => ({
    ...state,
    banner: banners,
    size: bannersSize,
    isLoading: false,
    loadingError: ''
  })),
  on(BannerTileActions.GetBannerTileError, (state, { error }) => ({
    ...state,
    banner: null,
    isLoading: false,
    loadingError: error
  }))
);

/* eslint-disable */
export function reducer(state: State | undefined, action: Action) {
  return bannerTileReducer(state, action);
}
